module.exports = __webpack_public_path__ + "img/deco-anniversaire.fe1a4b7.png";